import { DERIVED_DEPARTURE_EXPLANATION, derivedDepartureNote } from '../utils/derivedDepartures';
import { DepartureProvenanceNote } from './DepartureProvenanceNote';

export function DerivedDepartureNote({ count, color }: { count: number; color: string }) {
  return (
    <DepartureProvenanceNote
      count={count}
      color={color}
      testId="derived-departure-note"
      note={derivedDepartureNote}
      explanation={DERIVED_DEPARTURE_EXPLANATION}
    />
  );
}
